import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import TabsMenu from "../../components/TabsMenu";
import Loader from "../../components/Loader";
import {useNavigate} from "react-router-dom";
import {API, processApiResponse} from "../../services/HttpHandler";
import "./style.scss";
import BlockBtn from "../../components/BlockBtn";
import CancelConfirmBox from "../../components/CancelPopUp";
import {
  getCustomerSlotDetails,
  setCustomerSlotDetails,
} from "../../services/SessionStorage";
import {ADOBEDTM_PAGE_NAME} from "../../constants";
// import {dataDashboard} from "../../util";
import "../../components/Loader/style.scss";
import {cancelToken} from "../../services/turnero/turnero.service";
import ErrorModal from "../../components/Modal/errorModal";
import {getFirebase} from "../../services/firebaseclient";
import TokenBlockCard from "./token";
import BuSpecificHeader from "../../components/Header/BuSpecificHeader";

import config from "../../../config";

const DisplayTurnero = () => {
  const [loading, setLoading] = useState(false);
  const {t} = useTranslation();
  const navigate = useNavigate();
  const customerSlotDetails = useRef(getCustomerSlotDetails());
  const [error, setError] = useState("");
  const cancelTokenId = useRef("");
  const bookingId = useRef("");
  const [userQueueAppointments, setUserQueueAppointments] = useState([]);
  const [storeIdServiceTypeIdGroup, setStoreIdServiceTypeIdGroup] = useState(
    []
  );
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [errorTokenModal, setErrorTokenModal] = useState(false);
  const [firebaseTokenAvailable, setFirebaseTokenAvailable] = useState();
  const [isComponentInitialize, setIsComponentInitialize] = useState(false);

  const {urlLinkSource} = useSelector((state) => {
    return {
      urlLinkSource: state.globalReducer?.urlLinkSource || null,
    };
  });

  const showDetails = (val) => {
    if (val && val.tokenNumber) {
      let tempData = {};
      tempData["turneroDetails"] = val;
      setCustomerSlotDetails({
        ...customerSlotDetails.current,
        ...tempData,
      });
      navigate("/customer/currentattention", {replace: true});
    }
  };

  const showDeleteToken = (bookingid) => {
    const appSelectedDetail = userQueueAppointments.filter(
      (x) => bookingid === x.bookingId
    );
    const val = appSelectedDetail[0];
    if (val && val.tokenNumber) {
      cancelTokenId.current = val.tokenNumber;
      bookingId.current = val.bookingId;
      setOpenDeleteConfirm(true);
    }
  };
  const agreeDelete = () => {
    setLoading(true);
    let deleteInfo = {
      token: cancelTokenId.current,
    };
    customerSlotDetails.current.deleteTokenDetail = deleteInfo;
    setCustomerSlotDetails(customerSlotDetails.current);
    cancelToken(bookingId.current)
      .then(() => {
        deleteToken(bookingId.current);
      })
      .catch((err) => {
        setErrorTokenModal(true);
      })
      .finally(() => {
        setOpenDeleteConfirm(false);
        setLoading(false);
      });
    // const datamap = new Map();
    // datamap.set("events", "event8=1");
    // dataDashboard(datamap);
  };

  const deleteToken = (token) => {
    // showDeleteToken(token);

    for (let i = 0; i < userQueueAppointments.length; i++) {
      if (userQueueAppointments[i].bookingId === token) {
        userQueueAppointments.splice(i, 1);
        setUserQueueAppointments([...userQueueAppointments]);
        setIsComponentInitialize(false);
        break;
      }
    }
  };

  const handleNewTurnero = () => {
    // const datamap = new Map();
    // datamap.set("events", "event9=1");
    // dataDashboard(datamap);
    navigate("/customer/selectTurneroStoreAndType");
  };

  const handleBack = () => {
    // const datamap = new Map();
    // datamap.set("events", "event10=1");
    // dataDashboard(datamap);
    navigate("/customer/selectTurneroStoreAndType");
  };

  useEffect(() => {
    const tokenStatusUrl = config.endPoints.tokenStatus;
    const userIdPlaceholder = /userIdPlaceholder/gi;
    const url = tokenStatusUrl.replace(
      userIdPlaceholder,
      customerSlotDetails.current.userId
    );
    try {
      setLoading(true);
      API.get(url)
        .then(processApiResponse)
        .then((s) => {
          setUserQueueAppointments(s);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } catch (error) {
      setError("error occured");
      setLoading(false);
    } finally {
    }
  }, []);

  // useEffect(() => {
  //   // for data dashboard
  //   const URL = window.location.href.split("/")[2];
  //   const officeApp = customerSlotDetails.current.isOffice
  //     ? URL + "/office"
  //     : URL + "/app";
  //   const datamap = new Map();
  //   datamap.set("pageName", ADOBEDTM_PAGE_NAME.Turnero_Display_Tokens);
  //   datamap.set("prop1", URL);
  //   datamap.set("prop2", officeApp);
  //   dataDashboard(datamap);
  // }, []);

  useEffect(() => {
    const postdata = {};
    try {
      API.post(config.endPoints.firebasetoken, postdata)
        .then(processApiResponse)
        .then((response) => {
          setFirebaseTokenAvailable(response);
        });
    } catch (error) {
      setError(error?.message);
    } finally {
    }
  }, []);

  const firebaseInstance = async (fbToken) => {
    const instance = await getFirebase(fbToken);
    return instance.database();
  };

  const initializeFirebaseAndWaitingInQueue = function (fbToken) {
    const firebaseListenerTokenStatus = {};
    storeIdServiceTypeIdGroup.forEach(async (idsObject) => {
      firebaseListenerTokenStatus[`${idsObject.serviceTypeId}`] =
        await firebaseInstance(fbToken.toString());
      firebaseListenerTokenStatus[`${idsObject.serviceTypeId}`]
        .ref(
          "/" +
            idsObject.storeId +
            "/serviceTypes/" +
            idsObject.serviceTypeId +
            "/tokensInQueue"
        )
        .on("value", (snapshot) => {
          const data = snapshot.val();
          if (data && data.length > 0) {
            const queueList = [...userQueueAppointments];
            queueList.forEach((tokenDetail) => {
              const innerIndex = data.indexOf(tokenDetail.tokenNumber);
              if (
                innerIndex > -1 &&
                tokenDetail.serviceTypeId === idsObject.serviceTypeId
              ) {
                tokenDetail["peopleBeforeThisToken"] = innerIndex;
              } else if (
                tokenDetail["peopleBeforeThisToken"] == undefined ||
                tokenDetail["peopleBeforeThisToken"] == null
              ) {
                tokenDetail["peopleBeforeThisToken"] = 0;
              }
            });
            setUserQueueAppointments(queueList);
          }
        });
    });
  };

  const initializeFirebaseAndTokenStatus = function (fbToken) {
    const firebaseListenerTokenStatus = {};
    userQueueAppointments.forEach(async (token) => {
      firebaseListenerTokenStatus[`${token.bookingId}`] =
        await firebaseInstance(fbToken.toString());
      firebaseListenerTokenStatus[`${token.bookingId}`]
        .ref("/" + token.storeId + "/tokens/" + token.bookingId + "/status")
        .on("value", (snapshot) => {
          const data = snapshot.val();
          if (data === "DONE" || data == "ABSENT") {
            const tokenList = [...userQueueAppointments];
            const innerIndex = tokenList.findIndex(
              (tokenObject) => tokenObject.bookingId === token.bookingId
            );
            if (innerIndex > -1) {
              tokenList.splice(innerIndex, 1);
              setUserQueueAppointments([...tokenList]);
              setIsComponentInitialize(false);
            }
          }
        });
    });
  };

  useEffect(() => {
    if (
      !isComponentInitialize &&
      firebaseTokenAvailable &&
      firebaseTokenAvailable.length > 0 &&
      userQueueAppointments?.length &&
      storeIdServiceTypeIdGroup?.length
    ) {
      initializeFirebaseAndWaitingInQueue(firebaseTokenAvailable);
      initializeFirebaseAndTokenStatus(firebaseTokenAvailable);
      setIsComponentInitialize(true);
    }
  }, [
    firebaseTokenAvailable,
    userQueueAppointments,
    storeIdServiceTypeIdGroup,
  ]);

  useEffect(() => {
    const tokenList = [...userQueueAppointments];
    const groupList = [];
    tokenList.forEach((token) => {
      const ids = groupList.find((groupId) => {
        return (
          groupId?.storeId === token?.storeId &&
          groupId?.serviceTypeId === token?.serviceTypeId
        );
      });
      if (!ids) {
        groupList.push({
          storeId: token.storeId,
          serviceTypeId: token.serviceTypeId,
        });
      }
    });
    setStoreIdServiceTypeIdGroup([...groupList]);
  }, [userQueueAppointments]);

  const expandSelectedTurnero = (val) => {
    // const datamap = new Map();
    // datamap.set("events", "event52=1");
    // dataDashboard(datamap);
    const appSelectedDetail = userQueueAppointments.filter(
      (x) => val === x.bookingId
    );
    showDetails(...appSelectedDetail);
  };
  return loading ? (
    <div className="loader-container">
      <Loader />
    </div>
  ) : (
    <React.Fragment>
      {urlLinkSource === "web" ? <BuSpecificHeader /> : null}
      <TabsMenu path="displayTurnero" />
      <div className="displayTurnero-main-container  displayTurnero-main-container-background">
        {errorTokenModal ? (
          <ErrorModal
            text={t("cancel.shift.message")}
            performAction={agreeDelete}
            close={() => setErrorTokenModal(false)}
          />
        ) : (
          ""
        )}
        {!error ? (
          <>
            {openDeleteConfirm && (
              <CancelConfirmBox
                title={t("cancel.shift.title")}
                storeName={"currentAppointment.storeName"}
                close={() => setOpenDeleteConfirm(false)}
                performAction={() => agreeDelete()}
                turneroEnabled={true}
                isOffice={customerSlotDetails.current.isOffice}
              />
            )}
            <div className="turneroStatus-list">
              {userQueueAppointments.length > 0 ? (
                <div className="turneroStatus-list-wrap">
                  {userQueueAppointments.map((token) => (
                    <TokenBlockCard
                      key={token.tokenNumber}
                      tokenDetail={token}
                      expandSelectedTurnero={expandSelectedTurnero}
                      deleteSelectedTurnero={showDeleteToken}
                    />
                  ))}
                </div>
              ) : (
                <div className="no-bookings-page">
                  <div className="turneroStatus-no-bookings-logo"></div>
                  <div className="turneroStatus-no-bookings-header">
                    {t("myturnero.nobookingsavl.header")}
                  </div>
                  <div className="turneroStatus-no-bookings-text">
                    {t("myturnero.nobookingsavl")}
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="booking-error">{error}</div>
        )}
        <div className="displayTurnero-footer">
          <BlockBtn
            className="displayTurnero-button"
            name={t("book.shift")}
            handleClick={handleNewTurnero}
            disabled={false}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default DisplayTurnero;
